import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
};

const additionalChargesPendingSlice = createSlice({
  name: 'overweightUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters } = additionalChargesPendingSlice.actions;
const additionalChargesPendingReducer = additionalChargesPendingSlice.reducer;
export default additionalChargesPendingReducer;
